import { site } from "../data/content";
import Brand from "./Brand";
import { Link } from "react-router-dom";
import { Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-32 pt-16 pb-10"
      style={{ borderTop: "1px solid var(--border-soft)", backgroundColor: "var(--bg)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="REConsultX" className="h-9 w-9 object-contain" />
            <Brand size="lg" />
          </div>
          <p className="mt-4 text-sm max-w-xs" style={{ color: "var(--text-secondary)" }}>
            Renewable energy and industrial decarbonization advisory. Hybrid PV, Wind & Storage at Gigawatt scale.
          </p>
        </div>
        <div>
          <div className="overline mb-3">Site</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="link-underline">Home</Link></li>
            <li><Link to="/services" className="link-underline">Services</Link></li>
            <li><Link to="/projects" className="link-underline">Projects</Link></li>
            <li><Link to="/about" className="link-underline">About</Link></li>
            <li><Link to="/blog" className="link-underline">Blog</Link></li>
            <li><Link to="/contact" className="link-underline">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Reach</div>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={`mailto:${site.email}`} className="inline-flex items-center gap-2 link-underline" data-testid="footer-email">
                <Mail size={14} /> {site.email}
              </a>
            </li>
            <li style={{ color: "var(--text-secondary)" }}>{site.phone}</li>
            <li>
              <a href={site.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 link-underline" data-testid="footer-linkedin">
                <Linkedin size={14} /> LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs" style={{ color: "var(--text-secondary)" }}>
        <span>© {new Date().getFullYear()} REConsultX. All rights reserved.</span>
        <span className="font-mono">{site.url}</span>
      </div>
    </footer>
  );
}
